module.exports = __webpack_public_path__ + "static/img/Preface_logo.7d1ca8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Preface_logo.png
// module id = LNc5
// module chunks = 0